import { Heading, type HeadingProps } from "@/components/ui/heading.tsx";
import type { ReactNode } from "react";
import { cn } from "cn";

const PAGE_TITLE_CLASSES = "text-4xl leading-none font-normal sm:text-4xl";

export interface PageTitleProps extends Omit<HeadingProps, "level" | "children"> {
    children: ReactNode;
}

export function PageTitle({ children, className, ...rest }: PageTitleProps) {
    return (
        <Heading level={1} className={cn(PAGE_TITLE_CLASSES, className)} {...rest}>
            {children}
        </Heading>
    );
}
